import React from 'react'

const MissionVision = () => {
    return (
        <>

            <div className="course-area py-120" style={{marginTop:"-80px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center">
                                <span className="site-title-tagline"><i className="far fa-book-open-reader" /> About Us</span>
                                <h2 className="site-title">Mission & Vision</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-lg-4">
                            <div className="course-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="course-img">
                                    <img src="assets/school/misson.png" style={{ width: "100px", height: "100px" }} alt />
                                </div>
                                <div className="course-content">
                                    <h4 className="course-title mt-lg-4">
                                        <a to="course-single.html">Our Misson</a>
                                    </h4>
                                    <p className="course-text">
                                        To provide quality, holistic education that promotes academic excellence, creativity, and critical thinking. To foster a safe, inclusive, and supportive learning environment for every student.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="course-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="course-img">
                                    <img src="assets/school/Vision.png" style={{ width: "100px", height: "100px" }} alt />
                                </div>
                                <div className="course-content">
                                    <h4 className="course-title mt-lg-4">
                                        <a to="course-single.html">Our Vision</a>
                                    </h4>
                                    <p className="course-text">
                                        To become a center of excellence in education that nurtures knowledgeable, confident, and responsible individuals who are prepared to meet global challenges while upholding strong moral and cultural values.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="course-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="course-img">
                                    <img src="assets/school/Our Core Values.webp" style={{ width: "100px", height: "100px" }} alt />
                                </div>
                                <div className="course-content">
                                    <h4 className="course-title mt-lg-4">
                                        <a to="course-single.html">Our Core Values</a>
                                    </h4>
                                    <p className="course-text">
                                        <b style={{color:"black"}}>Integrity:- </b>
                                        We uphold honesty, transparency, and strong moral principles in all our actions.

                                        <b style={{color:"black"}}>Excellence:- </b>
                                        We strive for high standards in academics, co-curricular activities, and personal development.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default MissionVision